import Alpine from 'alpinejs';
import { MediaLayoutSwitcher } from './layout_switcher';
import { Layout } from '@/stores/layout_switcher/types';
import { LIST_COUNTER_INITIAL_VALUE } from '@/stores/layout_switcher/config';
import { attachInitToStoreInstance } from '@/utils/attach_init_to_store';

const mediaLayoutSwitcher = new MediaLayoutSwitcher({
    layout: Layout.ONE_COLUMN,
    listCounter: LIST_COUNTER_INITIAL_VALUE,
});
attachInitToStoreInstance(mediaLayoutSwitcher, MediaLayoutSwitcher);
Alpine.store('mediaLayoutSwitcher', mediaLayoutSwitcher);

export const appStore = Alpine.store('mediaLayoutSwitcher') as MediaLayoutSwitcher;
